module.exports = __webpack_public_path__ + "static/media/parents.d3ed59b4.svg";